import 'slick-carousel';
const [w,d,l] = [window,document,location]

export default function FEATURE () {

  const init = () =>{
    $('.p-sight__slider[data-plugin="slider"]').slick({
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      speed: 5000,
      pauseOnFocus: false,
      pauseOnHover: false,
      dots: false,
      centerMode: false,
      arrows: false,
      swipeToSlide:true,
      slidesToShow: 4,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      }]
    });
    $('.p-summary__slider[data-plugin="slider"]').slick({
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 500,
      centerMode: true,
      arrows: true,
      swipeToSlide:true,
      slidesToShow: 3,
      infinite: true,
      variableWidth: true,
      nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/next_arrow.png" width="100%"></button>',
      prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/prev_arrow.png" width="100%"></button>',
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
        }
      }]
    });

    if( l.search.match(/s=/) == null ){
      $('.p-header').removeClass('is-scrollview');
      
      // グローバルメニューをスクロール量で表示する
      $.scrollspy({
        trigger: 10,
        onBefore() {
          $('.p-header').removeClass('is-scrollview');
        },
        onAfter() {
          $('.p-header').addClass('is-scrollview');
        }
      })
    }
    
  }
  w.addEventListener('DOMContentLoaded',init)

}